var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-echarts-box",attrs:{"id":"box"}},[_c('div',{staticClass:"chart-echarts",attrs:{"id":"ranking_gauge_chart1"}}),_c('div',{staticClass:"chart-echarts",attrs:{"id":"ranking_gauge_chart2"}})])
}]

export { render, staticRenderFns }